import { Injectable, inject } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class ProductService {
  private api = inject(ApiService);

  getOne(id: number) { return this.api.get(`/product/${id}`); }
  upsert(json: any) { return this.api.post('/product', json); }
  create(json: any) { return this.api.post('/product/create', json); }
  remove(id: number) { return this.api.get(`/product/remove/${id}`); }
  updateTransactionAmount(id: number) { return this.api.get(`/product/${id}/transaction`); }
}
